(function() {
    'use strict';

    angular.module('user')
        .controller('ModelPermissionsGroupCreateController', ModelPermissionsGroupCreateController);

    ModelPermissionsGroupCreateController.$inject = ['$state', 'modelPermissionsGroupDataSrvc', 'notificationSrvc', 'modelPermissionsGroupMessagesConst', 'modelPermissionsDataSrvc', 'errorNotificationSrvc'];

    function ModelPermissionsGroupCreateController($state, modelPermissionsGroupDataSrvc, notificationSrvc, modelPermissionsGroupMessagesConst, modelPermissionsDataSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            permissions: [],
            nonFieldErrors: []
        };
        self.modelPermissionsGroupData = {
            name: '',
            permissions: [],
        };
        self.permissionList = [];

        self.createModelPermissionsGroup = createModelPermissionsGroup;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getPermissionList();
        }

        function getPermissionList() {
            return modelPermissionsDataSrvc.modelPermissions().$promise.then(
                function(response) {
                    self.permissionList = response;
                    return response;
                }
            );
        }

        function createModelPermissionsGroup() {
            modelPermissionsGroupDataSrvc.create(
                self.modelPermissionsGroupData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", modelPermissionsGroupMessagesConst.add);
                    $state.go('layout.modelPermissionsGroup.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
